.icon-style {
    color: var(--grey-lt);
    padding: 20px;
}

.chevron-style {
    color: var(--grey-lt);
}
